import { useEffect, useState } from 'react';
import usePublicPostApi from '~/public/lib/usePublicPostApi';
import * as ClientApi from '~/lib/ClientApi';
import TextInput from '~/components/TextInput';
import ClientLoginModal from '~/components/forms/questions/components/ClientLoginModal.jsx';
import { FormPart, part } from '~/lib/FormCssApi';

export const DEFAULT_LOGIN_DESCRIPTION =
    'Sign in to speed up the process, and save details to your account.';

export const DEFAULT_SKIP_DESCRIPTION =
    'You will have an opportunity to create an account later.';

const ClientLogin = ({ settings }) => {
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [isSkipped, setIsSkipped] = useState(false);

    if (isSkipped) {
        return (
            <div>
                <span
                    {...part(FormPart.ACCOUNT_DESCRIPTION)}
                    className="text-gray-500"
                >
                    Continuing as a guest
                </span>
                <button
                    type="button"
                    {...part(FormPart.ACCOUNT_BUTTON)}
                    className="form-button-light btn-small ml-6"
                    onClick={() => setIsSkipped(false)}
                >
                    Log in
                </button>
            </div>
        );
    }

    return (
        <div className="flex">
            <div className="flex-1 pr-6">
                <h3 {...part(FormPart.ACCOUNT_TITLE)}>Register or Log in</h3>
                <div
                    {...part(FormPart.ACCOUNT_DESCRIPTION)}
                    className="text-gray-500 my-2 text-base"
                >
                    {settings.loginDescription || DEFAULT_LOGIN_DESCRIPTION}
                </div>
                <button
                    type="button"
                    {...part(FormPart.ACCOUNT_BUTTON)}
                    className="form-button btn-small"
                    onClick={() => setShowLoginModal(true)}
                >
                    Register/Log in
                </button>
                <ClientLoginModal
                    isOpen={showLoginModal}
                    onClose={() => setShowLoginModal(false)}
                />
            </div>
            {!settings?.required && (
                <div className="flex-1 pl-6">
                    <h3 {...part(FormPart.ACCOUNT_TITLE)}>Skip</h3>
                    <div
                        {...part(FormPart.ACCOUNT_DESCRIPTION)}
                        className="text-gray-500 my-2 text-base"
                    >
                        {settings.skipDescription || DEFAULT_SKIP_DESCRIPTION}
                    </div>
                    <button
                        type="button"
                        {...part(FormPart.ACCOUNT_BUTTON)}
                        className="form-button-light btn-small"
                        onClick={() => setIsSkipped(true)}
                    >
                        Skip
                    </button>
                </div>
            )}
        </div>
    );
};

export default ClientLogin;
